<div class="max-w-xxl mx-auto mt-10 p-6 bg-white shadow rounded">
  <form class="max-w-md mx-auto" [formGroup]="signupForm" (ngSubmit)="submitForm()" novalidate>
    <div class="mb-4">
      <label class="block mb-1">First Name</label>
      <input type="text" formControlName="fname" class="w-full border p-2 rounded" />
      <p *ngIf="signupForm.get('fname')?.touched && signupForm.get('fname')?.invalid" class="text-red-500 text-sm">Required</p>
    </div>

    <div class="mb-4">
      <label class="block mb-1">Last Name</label>
      <input type="text" formControlName="lname" class="w-full border p-2 rounded" />
      <p *ngIf="signupForm.get('lname')?.touched && signupForm.get('lname')?.invalid" class="text-red-500 text-sm">Required</p>
    </div>

    <div class="mb-4">
      <label class="block mb-1">Email</label>
      <input type="email" formControlName="email" class="w-full border p-2 rounded" />
      <p *ngIf="signupForm.get('email')?.touched && signupForm.get('email')?.invalid" class="text-red-500 text-sm">Enter valid email</p>
    </div>

    <div class="mb-4">
      <label class="block mb-1">Phone</label>
      <input type="tel" formControlName="phone" class="w-full border p-2 rounded" />
      <p *ngIf="signupForm.get('phone')?.touched && signupForm.get('phone')?.invalid" class="text-red-500 text-sm">Enter valid 10-digit phone</p>
    </div>

    <div class="mb-4">
      <label class="block mb-1">Password</label>
      <input type="password" formControlName="password" class="w-full border p-2 rounded" />
      <p *ngIf="signupForm.get('password')?.touched && signupForm.get('password')?.invalid" class="text-red-500 text-sm">Min 6 characters</p>
    </div>

    <div class="mb-4 flex items-center">
      <input type="checkbox" formControlName="ack" class="mr-2" />
      <label>I acknowledge the terms</label>
    </div>
    <p *ngIf="signupForm.get('ack')?.touched && signupForm.get('ack')?.invalid" class="text-red-500 text-sm">You must acknowledge</p>

    <button type="submit" class="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700">Sign Up</button>
    <button type="button" class="bg-fuchsia-700 w-full mt-3 text-white px-4 py-2 rounded hover:bg-fuchsia-900" (click)="submitReferralWithoutToken()">
      Signup Without Token
    </button>
  </form>

  @if(signupForm.valid && captchaResponse) {
    <div class="mt-4">
      <h2 class="text-lg font-bold">Captcha Details</h2>
      <pre>{{ captchaResponse | json }}</pre>
    </div>
  }
  @if(captchaError) {
    <div class="mt-4">
      <pre class="text-red-500 text-sm">{{captchaError.error | json }}</pre>
    </div>
  }
</div>
